// removed by extract-text-webpack-plugin
module.exports = {"access_types":"access_types","access_types_header":"access_types_header","access_types_subtitle":"access_types_subtitle","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/AccessTypes/style.scss
// module id = 1326
// module chunks = 0